import { processImportResponse } from '../addBeerResponse';

const emptyNormalized = processImportResponse({});

/**
 * Merges multiple normalized addBeer import responses into one summary.
 */
export function mergeImportResponses(responses) {
  if (!Array.isArray(responses) || responses.length === 0) {
    return { ...emptyNormalized };
  }

  const normalizedList = responses.map((response) =>
    response?.addedCount != null ? response : processImportResponse(response ?? {}),
  );

  const merged = normalizedList.reduce(
    (accumulator, current) => ({
      status: current.status || accumulator.status,
      addedCount: accumulator.addedCount + (current.addedCount ?? 0),
      updatedCount: accumulator.updatedCount + (current.updatedCount ?? 0),
      duplicatedCount: accumulator.duplicatedCount + (current.duplicatedCount ?? 0),
      errorCount: accumulator.errorCount + (current.errorCount ?? 0),
      addedBeers: [...accumulator.addedBeers, ...(current.addedBeers ?? [])],
      updatedBeers: [...accumulator.updatedBeers, ...(current.updatedBeers ?? [])],
      duplicatedBeers: [...accumulator.duplicatedBeers, ...(current.duplicatedBeers ?? [])],
      errors: [...accumulator.errors, ...(current.errors ?? [])],
      beerDuplicateReviewId:
        current.beerDuplicateReviewId || accumulator.beerDuplicateReviewId || '',
    }),
    {
      status: '',
      addedCount: 0,
      updatedCount: 0,
      duplicatedCount: 0,
      errorCount: 0,
      addedBeers: [],
      updatedBeers: [],
      duplicatedBeers: [],
      errors: [],
      beerDuplicateReviewId: '',
    },
  );

  return merged;
}
